var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("h-content-type-" + _vm.contentType)},[(_vm.isUserMessage)?_c('UserMessage',{attrs:{"message":_vm.message}}):_c('AgentMessage',{attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }